

    require('./heatmap/HeatmapSeries');
    require('./heatmap/HeatmapView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/heatmap.js
// module id = 1173
// module chunks = 158